export default __webpack_public_path__ + "static/media/surfaceStudio-icon.5c7da3bc.svg";